import { render, staticRenderFns } from "./CameraHeader.vue?vue&type=template&id=2e042d1f&scoped=true"
import script from "./CameraHeader.vue?vue&type=script&lang=js"
export * from "./CameraHeader.vue?vue&type=script&lang=js"
import style0 from "./CameraHeader.vue?vue&type=style&index=0&id=2e042d1f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e042d1f",
  null
  
)

export default component.exports